var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "#FBFBFC",
    stroke: "#843EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2291 14.7079L40.0134 18.0683L43.8297 18.532L41.0294 21.0557L41.5895 24.7891L38.2291 22.6888L34.8687 24.7891L35.4287 21.0557L32.6284 18.532L36.5489 18.0683L38.2291 14.7079Z",
    fill: "#843EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9123 27.3082L35.7415 26.7504C35.3524 28.2494 34.5277 29.5994 33.3717 30.6299C32.2156 31.6605 30.7801 32.3252 29.2464 32.5403C27.7127 32.7553 26.1497 32.5109 24.7548 31.8381C23.36 31.1652 22.1958 30.094 21.4095 28.7598C20.6231 27.4256 20.2499 25.8883 20.3368 24.342C20.4238 22.7958 20.9671 21.31 21.8981 20.0724C22.8291 18.8348 24.106 17.9009 25.5675 17.3887C27.0291 16.8765 28.6096 16.8089 30.1095 17.1946L30.6684 15.0249C28.4819 14.4561 26.1677 14.6392 24.0978 15.5446C22.0279 16.4501 20.3226 18.0253 19.2561 20.017C18.1896 22.0087 17.8238 24.3012 18.2177 26.5258C18.6115 28.7505 19.742 30.7781 21.4274 32.2827V46.0715L28.1482 41.591L34.8689 46.0715V32.3029C36.3566 30.9769 37.416 29.2382 37.9123 27.3082ZM32.6287 41.8856L28.1482 38.8982L23.6676 41.8856V33.8061C25.0578 34.5044 26.5917 34.8687 28.1474 34.8698C29.703 34.871 31.2375 34.5091 32.6287 33.8128V41.8856Z",
    fill: "#843EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityRanking);
export default __webpack_public_path__ + "static/media/productivity-ranking.64c37ca970fd3f4e7c96de270c179c9a.svg";
export { ForwardRef as ReactComponent };